import create from 'zustand';
import { mountStoreDevtool } from 'simple-zustand-devtools';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import {
  processDate,
  parseTimestamp,
  getURLParameterByName,
  addOrUpdateUrlParam
} from '../helpers/helpers';
import { ColumnsSessions } from '../helpers/ColumnsSessions';
import { ColumnsEvents } from '../helpers/ColumnsEvents';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import { formatWithCursor } from 'prettier';
import { Undefined } from '@carbon/icons-react';
dayjs.extend(CustomParseFormat);

//wordpress global variable itu_social_events
declare const window: Window &
  typeof globalThis & {
    itu_eop: any;
  };

const useStore = create((set: any, get: any) => ({
  // STATE VALUES
  // Define state values and defaults
  view: 'card',
  currentEventPage: 1, //for cards pagination start at  page 1
  eventsPerPage: 9, //9 cards per page
  currentSessionPage: 1,
  sessionsPerPage: 9,
  datasetType: 'new',
  loading: false,
  ajaxUrl: '',
  eventId: '',
  isFiltering: false,
  columnsGridSessions: '',
  columnsGridEvents: '',
  gridOptions: { listType: 'fulllist', rowHeight: 50 },
  filters: {
    searchSession: '',
    MySessions: 0, //0 or 1: to filter logged-in user sessions
    searchEvent: '',
    DateSession: '',
    TimeSession: '',
    DateEvent: '',
    TimeEvent: '',
    Venue: '',
    Agendaitem: '',
    Message: '',
    SectorSession: '', //state variable for each sector filter for sessions
    SectorEvent: '',
    MeetingType: '',
    Committee: '',
    SubGroup: '',
    Sectors: '',
    Types: '',
    Groups: '',
    Formats: '',
    SectorGroups: ''
  },
  currentevents: [{}],
  sessions: [{}],
  pastSessions: [{}],
  newSessions: [{}],
  events: [{}],
  pastEvents: [{}],
  newEvents: [{}],
  dateSessions: [],
  timeSessions: [],
  dateEvents: [],
  timeEvents: [],
  messages: [], //invitation to
  slots: [],
  venues: [],
  agendaitems: [],
  meetingtypes: [],
  committees: [], //committee
  subgroups: [],
  sectorssessions: [], //state variable for multiple sector filter array for sessions
  sectorsevents: [],
  sectors: [],
  types: [],
  groups: [],
  formats: [],
  sectorgroups: [],
  order: [{}],
  loaded_slots: [{}],
  settings: {
    is_multisite: false,
    current_blog: 1,
    localize_index: 0,
    params: {
      view: 'card', //' calendar|list|card'
      type: 'events', //sessions|events
      activeRoute: 'events',
      eventid: '',
      startdatesession: '', //start date session
      displayfilters: {
        sectorsession: 1,
        meetingtype: 1,
        committee: 1,
        subgroup: 1,
        venue: 1,
        agendaitem: 1
      },
      displaycolumnssessions: {
        MonitorTitle: 1,
        TimeSessionStartEnd: 1,
        DateSession: 1,
        AgendaItems: 1,
        CommitteeSubGroup: 1,
        RoomName: 1,
        Building: 1,
        MeetingType: 1,
        Message: 0,
        Notes: 0,
        CalendarDate: 0,
        actions: 1
      },
      eventtype: '',
      hideheader: '0',
      ituAuth: '', //session token stored as a cookie
      isLoggedIn: 'false',
      eventName: '',
      eventDateStartEnd: '',
      eventPlace: '',
      eventGroup: '',
      eventSector: '',
      darkTheme: '1',
      viewMySessions: '0' //true when you click on my sessions button
    }
  },
  MUIdata: { rows: [], columns: [] },
  MUIdataSessions: { rows: [], columns: [] },
  MUIdataEvents: { rows: [], columns: [] },

  // METHODS
  // State methods
  // Toggle loading state
  toggleLoading: (loadingValue: boolean) => {
    switch (loadingValue) {
      case true:
        set((state: any) => ({ ...state, loading: true }));
        break;

      case false:
        set((state: any) => ({ ...state, loading: false }));
        break;

      //default:
      // set((state: any) => ({ ...state, loading: !state.loading }));
    }
  },

  // Set a param value
  setParams: (key: any, value: any) => {
    let wpSettings = get().settings; //load local settings
    wpSettings.params[key] = value;

    set((state: any) => ({ ...state, settings: wpSettings }));
  },

  // Set a filter value
  setFilter: (key: any, value: any) => {
    set((state: any) => ({ ...state, filters: { ...state.filters, [key]: value } }));

    //console.log(get().filters.DateSession)

    //rebuild muidata on base of filtering
    if (
      get().settings.params.activeRoute == 'sessions' ||
      get().settings.params.eventid !== '' ||
      get().settings.params.startdatesession !== '' ||
      get().settings.params.eventtype !== ''
    )
      get().buildMUIDataSessions();
    if (get().settings.params.activeRoute == 'events') get().buildMUIDataEvents();
  },

  setFiltering: () => {
    const filtersObject = get().filters;

    if (
      filtersObject.searchSession !== '' ||
      filtersObject.MySessions !== '' ||
      filtersObject.searchEvent !== '' ||
      filtersObject.DateSession !== '' ||
      filtersObject.TimeSession !== '' ||
      filtersObject.DateEvent !== '' ||
      filtersObject.TimeEvent !== '' ||
      filtersObject.Venue !== '' ||
      filtersObject.Agendaitem !== '' ||
      filtersObject.Message !== '' ||
      filtersObject.MeetingType !== '' ||
      filtersObject.Sectors !== '' ||
      filtersObject.Types !== '' ||
      filtersObject.Groups !== '' ||
      filtersObject.SectorGroups !== '' ||
      filtersObject.Formats !== '' ||
      filtersObject.SubGroup !== '' ||
      filtersObject.Committee !== ''
    )
      set((state: any) => ({ ...state, isFiltering: true }));
  },

  setActiveRoute: (activeRoute: string) => {
    set({ activeRoute, showNav: activeRoute !== 'preview' });
  },

  // Set the ajax url value depending on data source
  changeAjaxUrl: (datasource: string) => {
    switch (datasource) {
      case 'GetCurrentEvents':
        //social events url
        set((state: any) => ({
          ...state,
          ajaxUrl: 'https://www.itu.int/net/CRM/api/eop/Events/GetCurrentEvents'
        }));
        break;
      case 'GetCurrentSessions':
        //social events url
        set((state: any) => ({
          ...state,
          ajaxUrl: 'https://www.itu.int/net/CRM/api/eop/Sessions/GetCurrentSessions'
        }));
        break;
    }
  },

  // change the eventid value
  changeEventID: (eventId: any) => {
    //set((state: any) => ({ ...state, eventId: eventId }));

    let wpSettings = get().settings; //load local settings
    wpSettings.params.eventid = eventId; //set new eventid
    wpSettings.params.activeRoute = 'sessions'; //set new activeRoute

    set((state: any) => ({ ...state, settings: wpSettings }));
  },

  // change the viewMySessions value
  changeViewMySessions: (viewMySessions: any) => {
    let wpSettings = get().settings; //load local settings
    wpSettings.params.viewMySessions = viewMySessions; //set new eventid
    //wpSettings.params.activeRoute = 'sessions' //set new activeRoute

    set((state: any) => ({ ...state, settings: wpSettings }));
  },

  // change the StartDateSession value
  changeStartDateSession: (StartDateSession: any) => {
    let wpSettings = get().settings; //load local settings
    wpSettings.params.startdatesession = StartDateSession; //set new StartDateSession
    wpSettings.params.activeRoute = 'sessions'; //set new activeRoute

    set((state: any) => ({ ...state, settings: wpSettings }));
  },

  // change the eventtype value
  changeEventType: (eventtype: any) => {
    let wpSettings = get().settings; //load local settings
    wpSettings.params.eventtype = eventtype; //set new eventtype

    set((state: any) => ({ ...state, settings: wpSettings }));
  },

  // Set the current pagination page value for card event
  changeCurrentEventPage: (pageNum: number) => {
    set((state: any) => ({ ...state, currentEventPage: pageNum }));
  },

  // Set the current pagination page value for card session
  changeCurrentSessionPage: (pageNum: number) => {
    set((state: any) => ({ ...state, currentSessionPage: pageNum }));
  },

  // Set the view value
  changeView: (viewname: string) => {
    let wpSettings = get().settings; //load local settings
    wpSettings.params.view = viewname; //set new view

    set((state: any) => ({ ...state, settings: wpSettings }));
  },

  // Set the grid columns value
  changeColumnsGrid: (activeRoute: string) => {
    switch (activeRoute) {
      case 'sessions':
        //sessions columns
        set((state: any) => ({ ...state, columnsGrid: ColumnsSessions }));
        break;

      case 'events':
        //side events columns
        set((state: any) => ({ ...state, columnsGrid: ColumnsEvents }));
        break;

      default:
      //daily schedule columns
      // set((state) => ({ ...state, columnsGrid: ColumnsDailySchedule }));
    }
  },

  // change dataset to old or new sessions data
  changeDataSet: () => {
    // Define empty data grid
    let dataGrid = { rows: [], columns: [] };

    // GET datagrid columns state depending on the datasource. see function changeColumnsGrid
    dataGrid.columns = get().columnsGrid;

    // Save the datagrid to the store
    set((state: any) => ({ ...state, MUIdata: dataGrid }));

    if (get().datasetType === 'new') {
      //load past sessions
      set((state: any) => ({ ...state, sessions: state.pastSessions }));
      set((state: any) => ({ ...state, events: state.pastEvents }));

      //change datasettype
      set((state: any) => ({ ...state, datasetType: 'past' }));
    } else {
      //set((state) => ({state, sessions: [] }));
      set((state: any) => ({ ...state, sessions: state.newSessions }));
      set((state: any) => ({ ...state, events: state.newEvents }));
      set((state: any) => ({ ...state, datasetType: 'new' }));
    }

    get().buildMUIData();
  },

  /**
   * Determines if the current page is in an iframe element.
   *
   * @return bool True if the frame is in an iframe; otherwise, false.
   */
  isPageInIframe: () => {
    return window.location !== window.parent.location;
  },

  //get cookies from parent iframe. useful when application is embedded in iframe
  getParentIframeCookie(name: string): string {
    const nameLenPlus = name.length + 1;
    return (
      window.parent.document.cookie
        .split(';')
        .map((c) => c.trim())
        .filter((cookie) => {
          return cookie.substring(0, nameLenPlus) === `${name}=`;
        })
        .map((cookie) => {
          return decodeURIComponent(cookie.substring(nameLenPlus));
        })[0] || ''
    );
  },
  // Update the settings if in a wp-environment from the localize script data
  updateSettings: () => {
    //get the wpsettings from gutenberg\render_callbacks\render_social_events.php

    let localWindowSettings = window.itu_eop;
    let wpSettings = get().settings;
    //console.log(window.itu_social_events)

    if (localWindowSettings !== null && localWindowSettings !== undefined) {
      //console.log('local wordpress settings: '+JSON.stringify(localWindowSettings))
      //console.log('app default settings: '+JSON.stringify(wpSettings))

      wpSettings.params = Object.assign(wpSettings.params, localWindowSettings.params); //load wordpress settings
    }

    //check if ituAuth cookie is defined in the parent iframe
    if (get().isPageInIframe() == true) {
      const ituAuth = get().getParentIframeCookie('ituAuth');
      //console.log('ituAuth: '+ituAuth)
      if (ituAuth !== null && ituAuth !== undefined) {
        wpSettings.params.ituAuth = ituAuth;
        wpSettings.params.isLoggedIn = 'true';
        //console.log(wpSettings)
      }
    }

    /*const ituAuth = Cookies.get('ituAuth')
    if (ituAuth !== null && ituAuth !== undefined) {
      wpSettings.params.ituAuth = ituAuth
      //console.log(wpSettings)
    }
    else {*/

    // Cookies.set('ituAuth', 'ewogICJhbGciOiJSUzI1NiIsCiAgImtpZCI6Imp3ay1pdHUta2V5IiwKICAidHlwIjoiSldUIgp9.ewogICJ0b2tlbl90eXBlIjoiQmVhcmVyIiwKICAic2NvcGUiOiJlbWFpbCBwcm9maWxlIiwKICAic2NvcGVfZGF0YSI6WwogICAgewogICAgICAgICJpZCI6ImVtYWlsIiwKICAgICAgICAidmFsdWUiOiIiCiAgICB9LAogICAgewogICAgICAgICJpZCI6InByb2ZpbGUiLAogICAgICAgICJ2YWx1ZSI6IiIKICAgIH0KICBdLAogICJpc3MiOiJodHRwczovL29hdXRoLml0dS5pbnQvZjUtb2F1dGgyL3YxLyIsCiAgImF1dGhkb21haW4iOiJibHVlIiwKICAiYnItaWZpYy1zcGFjZS1vbmxpbmUtbWVtYmVyc2hpcCI6ImZhbHNlIiwKICAiZW1haWwiOiJrb2Rqby50Y2hpb2Zmb0BpdHUuaW50IiwKICAiZmFtaWx5X25hbWUiOiJUY2hpb2ZmbyIsCiAgImdpdmVuX25hbWUiOiJLb2RqbyIsCiAgImlzX2Rtcy1zLWNsX21lbWJlciI6ImZhbHNlIiwKICAiaXNfZG1zLXMtcmNsX21lbWJlciI6ImZhbHNlIiwKICAiaXNfdGllc19tZW1iZXIiOiJmYWxzZSIsCiAgIm5hbWUiOiJ0Y2hpb2ZmbyIsCiAgInByZWZlcnJlZF91c2VybmFtZSI6ImtvZGpvLnRjaGlvZmZvQGl0dS5pbnQiLAogICJzdWIiOiIvQ29tbW9uL2FjY2Vzcy10ZXN0LW9hdXRoLiIsCiAgImp0aSI6ImU1Yjk4ZWUyMzM1NWVlZDExYTQ5MGRjM2RhMjgyMmVhOWUzYzBlY2Y2NDEzM2Y1MDUyNzAzZmYxOGVjYmFmMWEiLAogICJpYXQiOjE2OTk0Mzg1MDcsCiAgImV4cCI6MTY5OTQ4MTcwNywKICAibmJmIjoxNjk5NDM4MjA3Cn0.oTgpLUQCgNoAHFCoRV_tdL7Cd3_h6zJ81Kn-Eajmk6PTlZc7biaCOsrRDZtmOUqHp9qxCTIF7mG5ZLluQsou5M-epNJ7YqNP4G9QpqSEQg_kuiclZXO_17G_t9Al4fJyWt3FmPmvsumZ6Sv6v9XdGXF5FxRJjN8OiT8DoCcuJmPhXJmZWxbHITgI9sjnDELb_M8hT8sjaLfK5HwczBdU-loe1T09SGbJdhZ-zbZJOdduVpHyEJ6gxc_J5jZLb5rzqihZH3b7jTqZirO1L65_FAVz_P38hMLgHP3g8uMDZVZNxNIhX-NzxV7XC-2JGpZLXhaEmwer_hAweBmQ3VvBUvNTo-GX569U_uPBoFNrlLeOKzatI9OoZO8DSj7ZrvwhpBsjanLX90eLyWjCdU2ynCJDn5wKpWgsxtLwXLGMJfj31nSUc2Nkm3uI2nxRuqj6IEz_LWfRdBsHK6eN4yOApRiGpB9_sdCunMGBVUu_PXiakezzKAuIF4DJhgIIcKbUaCgRfJS5-oPmxtMSFbkCHQPn_52UgzTJQG-8ofH-sJ86QKQLI0V36KmdnQj1HrxJdAt05wBXUA2BSh_OU6WvB9emqzXpNaWeOBReLKc2aePVqLsY-yskBMu3QwsLVG7evzK3rG9YbTv1JVhm5s0efoMnMJ5A00PP3PSdcnCHWm8')
    //wpSettings.params.ituAuth = Cookies.get('ituAuth')
    //}

    //check if eventid is set in the url: if it is the case load it
    const eventId = getURLParameterByName('eventid');
    if (eventId !== null && eventId !== undefined) {
      wpSettings.params.eventid = eventId;
      //console.log(wpSettings)
    }

    //check if type/activeRoute (sessions/events) is set in the url: if it is the case load it
    const type = getURLParameterByName('type');
    if (type !== null && type !== undefined) {
      wpSettings.params.type = type;
      //console.log(wpSettings)
    }

    //check if view (card/calendar/lits) is set in the url: if it is the case load it
    const view = getURLParameterByName('view');
    if (view !== null && view !== undefined) {
      wpSettings.params.view = view;
      //console.log(wpSettings)
    }

    //check if startdatesession is set in the url: if it is the case load it
    const startdatesession = getURLParameterByName('startdatesession');
    if (startdatesession !== null && startdatesession !== undefined) {
      wpSettings.params.startdatesession = startdatesession;
      //console.log(wpSettings)
    }

    //check if eventtype is set in the url: if it is the case load it
    const eventtype = getURLParameterByName('eventtype');
    if (eventtype !== null && eventtype !== undefined) {
      wpSettings.params.eventtype = eventtype;
      //console.log(wpSettings)
    }

    //check if hideHeader is set in the url: if it is the case hide the header component
    const hideheader = getURLParameterByName('hideheader');
    if (hideheader !== null && hideheader !== undefined) {
      wpSettings.params.hideheader = hideheader;
      //console.log(wpSettings)
    }

    //check if displayfilters is set in the url: if it is the case display the right filters component
    const displayfilters = JSON.parse(getURLParameterByName('displayfilters') || '{}');
    if (
      displayfilters !== null &&
      displayfilters !== undefined &&
      JSON.stringify(displayfilters) !== '{}'
    ) {
      //displayfilters:{sectorsession:1,meetingtype:1,committee:1,venue:1,agendaitem:1}
      //console.log('displayfilters'+JSON.stringify(displayfilters))

      if (Object.prototype.hasOwnProperty.call(displayfilters, 'sectorsession'))
        wpSettings.params.displayfilters.sectorsession = displayfilters.sectorsession;

      if (Object.prototype.hasOwnProperty.call(displayfilters, 'meetingtype'))
        wpSettings.params.displayfilters.meetingtype = displayfilters.meetingtype;

      if (Object.prototype.hasOwnProperty.call(displayfilters, 'meetingtype'))
        wpSettings.params.displayfilters.committee = displayfilters.committee;

      if (Object.prototype.hasOwnProperty.call(displayfilters, 'venue'))
        wpSettings.params.displayfilters.venue = displayfilters.venue;

      if (Object.prototype.hasOwnProperty.call(displayfilters, 'agendaitem'))
        wpSettings.params.displayfilters.agendaitem = displayfilters.agendaitem;

      if (Object.prototype.hasOwnProperty.call(displayfilters, 'subgroup'))
        wpSettings.params.displayfilters.subgroup = displayfilters.subgroup;

      //console.log(wpSettings)
    }

    //check if displaycolumnssessions is set in the url: if it is the case display the right filters component
    const displaycolumnssessions = JSON.parse(
      getURLParameterByName('displaycolumnssessions') || '{}'
    );
    if (
      displaycolumnssessions !== null &&
      displaycolumnssessions !== undefined &&
      JSON.stringify(displaycolumnssessions) !== '{}'
    ) {
      /* MonitorTitle: 1, TimeSessionStartEnd: 1,
       DateSession: 1, AgendaItems: 1, 
       CommitteeSubGroup: 1, RoomName: 1, Building: 1,
        MeetingType: 1, Message: 0, Notes: 0,
         CalendarDate: 0, actions: 1 */
      //console.log(displayfilters)

      if (Object.prototype.hasOwnProperty.call(displaycolumnssessions, 'MonitorTitle'))
        wpSettings.params.displaycolumnssessions.MonitorTitle = displaycolumnssessions.MonitorTitle;

      if (Object.prototype.hasOwnProperty.call(displaycolumnssessions, 'TimeSessionStartEnd'))
        wpSettings.params.displaycolumnssessions.TimeSessionStartEnd =
          displaycolumnssessions.TimeSessionStartEnd;

      if (Object.prototype.hasOwnProperty.call(displaycolumnssessions, 'DateSession'))
        wpSettings.params.displaycolumnssessions.DateSession = displaycolumnssessions.DateSession;

      if (Object.prototype.hasOwnProperty.call(displaycolumnssessions, 'AgendaItems'))
        wpSettings.params.displaycolumnssessions.AgendaItems = displaycolumnssessions.AgendaItems;

      if (Object.prototype.hasOwnProperty.call(displaycolumnssessions, 'CommitteeSubGroup'))
        wpSettings.params.displaycolumnssessions.CommitteeSubGroup =
          displaycolumnssessions.CommitteeSubGroup;

      if (Object.prototype.hasOwnProperty.call(displaycolumnssessions, 'RoomName'))
        wpSettings.params.displaycolumnssessions.RoomName = displaycolumnssessions.RoomName;

      if (Object.prototype.hasOwnProperty.call(displaycolumnssessions, 'Building'))
        wpSettings.params.displaycolumnssessions.Building = displaycolumnssessions.Building;

      if (Object.prototype.hasOwnProperty.call(displaycolumnssessions, 'MeetingType'))
        wpSettings.params.displaycolumnssessions.MeetingType = displaycolumnssessions.MeetingType;

      if (Object.prototype.hasOwnProperty.call(displaycolumnssessions, 'Message'))
        wpSettings.params.displaycolumnssessions.Message = displaycolumnssessions.Message;

      if (Object.prototype.hasOwnProperty.call(displaycolumnssessions, 'Notes'))
        wpSettings.params.displaycolumnssessions.Notes = displaycolumnssessions.Notes;

      if (Object.prototype.hasOwnProperty.call(displaycolumnssessions, 'CalendarDate'))
        wpSettings.params.displaycolumnssessions.CalendarDate = displaycolumnssessions.CalendarDate;

      if (Object.prototype.hasOwnProperty.call(displaycolumnssessions, 'actions'))
        wpSettings.params.displaycolumnssessions.actions = displaycolumnssessions.actions;
    }

    if (wpSettings) {
      //console.log(wpSettings)
      //set ajax url to social_events or daily schedule or side_events
      //get().changeAjaxUrl(wpSettings.params.datasource)

      //load the settings state
      set((state: any) => ({ ...state, settings: wpSettings }));

      //activate viewtype selection from wordpress
      /*if(wpSettings.params.viewtype!== undefined && wpSettings.params.viewtype!== '')
      {
      get().changeView(wpSettings.params.viewtype);
      }*/
    } else {
      console.log('No wp settings found');
    }
  },

  // Get the current events
  GetCurrentEvents: async () => {
    // Set REST API endpoints
    let eventsEndpoint = 'https://www.itu.int/net/CRM/api/eop/events/'; //get the ajax url state
    //'https://devweb19.itu.int/net/CRM/api/eop/events/'; //get the ajax url state
    //'https://devweb19.itu.int/net/CRM/api/eop/Events/GetCurrentEvents'; //get the ajax url state
    //'https://www.itu.int/net/CRM/api/eop/Events/GetCurrentEvents'; //get the ajax url state

    //date filter
    let dateFilter = dayjs(new Date()).format('YYYY-MM-DD'); //date parameter (default today)
    if (dateFilter !== '') eventsEndpoint = eventsEndpoint + '?date=' + dateFilter;

    // console.log(eventsEndpoint);

    const dateToday = dayjs(new Date()).format('DD/MM/YYYY'); // "28/09/2022"//

    get().toggleLoading(true);

    // Set sessions and session related store parts
    await fetch(eventsEndpoint)
      .then((res) => res.json())
      .then((jsondata) => {
        //console.log(jsondata);

        let newEvents: any = [];
        let pastEvents: any = [];

        let sectorsevents: any = [];
        let types: any = [];
        let groups: any = [];
        let formats: any = [];
        let sectorgroups: any = [];

        const data: any = jsondata; // .d.results;

        data.forEach((event: any) => {
          /*****fill-in the dateEvents array state*/
          const dateEvent = dayjs(event.start).format('DD/MM/YYYY');
          //console.log(dateEvent);

          // if (processDate(dateEvent) >= processDate(dateToday)) {
          newEvents.push(event);
          //} else {
          //  pastEvents.push(event);
          //}

          if (!sectorsevents.includes(event.sector) && event.sector) {
            sectorsevents.push(event.sector);
          }

          if (!types.includes(event.type) && event.type) {
            types.push(event.type);
          }

          if (!groups.includes(event.group) && event.group) {
            groups.push(event.group);
          }

          if (!formats.includes(event.format) && event.format) {
            formats.push(event.format);
          }

          let sectorGroup = event.group + ' - ' + event.sector;
          if (!sectorgroups.includes(sectorGroup) && sectorGroup) {
            sectorgroups.push(sectorGroup);
          }
        });
        //console.log(pastEvents);

        /**sort new and past events array by date and set state */
        //sort data by date from asc
        sectorsevents.sort();
        types.sort();
        groups.sort();
        formats.sort();
        sectorgroups.sort();

        set((state: any) => ({ ...state, sectorsevents: sectorsevents }));
        set((state: any) => ({ ...state, types: types }));
        set((state: any) => ({ ...state, groups: groups }));
        set((state: any) => ({ ...state, formats: formats }));
        set((state: any) => ({ ...state, sectorgroups: sectorgroups }));

        pastEvents.sort(function (a: any, b: any) {
          const dateA = dayjs(a.start);
          //console.log(a.start);
          const dateB = dayjs(b.start);

          return dateA.diff(dateB);
        });

        newEvents.sort(function (a: any, b: any) {
          const dateA = dayjs(a.start);
          //console.log(a.start);
          const dateB = dayjs(b.start);

          return dateA.diff(dateB);
        });

        set((state: any) => ({ ...state, events: newEvents }));

        set((state: any) => ({ ...state, pastEvents: pastEvents }));
        set((state: any) => ({ ...state, newEvents: newEvents }));
      });

    // Rebuild the MUI datatable data
    //get().buildMUIData();
    get().buildMUIDataEvents();
  },

  // Get the current sessions
  GetCurrentSessions: async () => {
    // Set REST API endpoints
    let sessionsEndpoint = 'https://www.itu.int/net/CRM/api/eop/events/sessions';
    //'https://devweb19.itu.int/net/CRM/api/eop/events/sessions'
    //https://www.itu.int/net/eop/test2.json';
    //'https://www.itu.int/net/CRM/api/eop/Sessions/GetEventSessions?eventId=18465';
    //'https://www.itu.int/net/eop/test.json';
    //let sessionsEndpoint = 'https://www.itu.int/net/CRM/api/eop/Sessions/GetCurrentSessions'; //get the ajax url state

    //date filter
    let dateFilter = dayjs(new Date()).format('YYYY-MM-DD'); //date parameter (default today)
    //let dateFilter = '2023-02-08';
    //if (dateFilter !== '') sessionsEndpoint = sessionsEndpoint + '?date=' + dateFilter;

    //initialize sessions state
    set((state: any) => ({ ...state, sessions: [] }));

    console.log(sessionsEndpoint);

    get().fetchSessions(sessionsEndpoint); //fetch sessions from the api
  },

  // Get the sessions for eventId and eventtype
  GetEventSessions: async () => {
    let sessionsEndpoint = 'https://www.itu.int/net/CRM/api/eop/events/';
    //'https://devweb19.itu.int/net/CRM/api/eop/events/'
    //'https://www.itu.int/net/eop/test2.json'
    //

    //event id
    let eventId = get().settings.params.eventid;
    if (eventId !== '') sessionsEndpoint = sessionsEndpoint + eventId + '/sessions';
    //addOrUpdateUrlParam(sessionsEndpoint, 'eventId', eventId);

    // Set REST API endpoints
    //18465/sessions
    //'https://www.itu.int/net/CRM/api/eop/Sessions/GetEventSessions'; //get the ajax url state

    //eventtype
    let eventtype = get().settings.params.eventtype;
    //console.log('type:' + eventtype);
    if (eventtype !== '')
      sessionsEndpoint = addOrUpdateUrlParam(sessionsEndpoint, 'type', eventtype);

    get().fetchSessions(sessionsEndpoint); //fetch sessions from the api
  },

  // Get the sessions for logged-in user
  GetMySessions: async () => {
    let sessionsEndpoint = 'https://www.itu.int/net/CRM/api/eop/events/mysessions';
    //'https://devweb19.itu.int/net/CRM/api/eop/events/'
    //'https://www.itu.int/net/eop/test2.json'
    //

    console.log(sessionsEndpoint);

    get().fetchSessions(sessionsEndpoint); //fetch sessions from the api
  },

  //check if the token is expired
  isTokenExpired: (token: string) => {
    const expiry = JSON.parse(atob(token.split('.')[1])).exp;
    return Math.floor(new Date().getTime() / 1000) >= expiry;
  },

  //add authoriation token headers to json fetch request
  getTokenHeaders: () => {
    const ituAuth = get().settings.params.ituAuth;
    if (ituAuth !== '' && ituAuth !== undefined) {
      const isTokenExpired = get().isTokenExpired(ituAuth);

      console.log('token expired' + isTokenExpired);

      if (isTokenExpired == false) {
        //console.log('token : '+ituAuth)

        const myHeaders = new Headers({
          accept: 'application/json',
          Authorization: `Bearer ${ituAuth}`
        });

        return myHeaders;
      } else {
        console.log('token expired');
      }
    } else {
      console.log('no token available');
    }
  },
  //fetch sessions from the api
  fetchSessions: async (sessionsEndpoint: string) => {
    //dateformat to sort array
    const dateToday = dayjs(new Date()).format('DD/MM/YYYY'); // "28/09/2022"//

    const headers = get().getTokenHeaders();
    //console.log(headers)
    //const ituAuth= get().settings.params.ituAuth;

    get().toggleLoading(true);

    // Set sessions and session related store parts
    await fetch(sessionsEndpoint, {
      headers: headers
    })
      .then((res) => res.json())
      .then((jsondata) => {
        // console.log(jsondata);

        let newSessions: any = [];
        let pastSessions: any = [];

        /***declare the filters array (sector, etc) */
        let sectorssessions: any = [];
        let meetingtypes: any = [];
        let venues: any = [];
        let agendaitems: any = [];
        let datesessions: any = [];
        let committees: any = [];
        let subgroups: any = [];

        //eventtype
        let eventtype = get().settings.params.eventtype;
        let arrayEventTypes: string[];
        if (eventtype !== '') arrayEventTypes = eventtype.split(',');

        const data: any = jsondata; // .d.results;

        data.forEach((session: any) => {
          //filter by event type when fetching data
          if (
            arrayEventTypes === undefined ||
            (arrayEventTypes.length > 0 && arrayEventTypes.includes(session.type))
          ) {
            //console.log(dateSession);

            //if (!(processDate(dateSession) >= processDate(dateToday))) {
            newSessions.push(session);
            //} else {
            //  pastSessions.push(session);
            //}

            /*****fill-in the dateSessions array state*/
            const dateSession = dayjs(session.start).format('DD/MM/YYYY');

            if (!datesessions.includes(dateSession)) {
              datesessions.push(dateSession);
            }

            /*****fill-in the sectors filters array */
            if (!sectorssessions.includes(session.sector) && session.sector) {
              sectorssessions.push(session.sector);
            }

            /*****fill-in the committee filters array */
            if (!committees.includes(session.committee) && session.committee) {
              committees.push(session.committee);
            }

            /*****fill-in the subgroup filters array */
            if (!subgroups.includes(session.subGroup) && session.subGroup) {
              subgroups.push(session.subGroup);
            }

            /*****fill-in the meetingtypes filters array */
            if (!meetingtypes.includes(session.type) && session.type) {
              meetingtypes.push(session.type);
            }

            /*****fill-in the venues filters array */
            if (!venues.includes(session.room) && session.room) {
              venues.push(session.room);
            }

            /*****fill-in the agendaitems filters array */
            if (session.agendaItems && session.agendaItems.length > 0) {
              //parse to json array
              let jsonArray = session.agendaItems; //JSON.parse(session.agendaItems.toString().replace(/'/g, '"'))
              //loop through array of agenda items and push it in the array list
              for (var i = 0; i < jsonArray.length; i++) {
                //console.log(session.agendaItems[i]);
                if (!agendaitems.includes(jsonArray[i])) {
                  agendaitems.push(jsonArray[i]);
                }
              }
            }
          }
        });

        //console.log(newSessions);
        //console.log(sectors);

        /**(mutate) state of datesessions */
        //console.log(datesessions)
        set((state: any) => ({ ...state, dateSessions: datesessions }));

        /**sort sectors array and set(mutate) state */
        sectorssessions.sort();
        set((state: any) => ({ ...state, sectorssessions: sectorssessions }));

        /**sort committees array and set(mutate) state */
        committees.sort();
        set((state: any) => ({ ...state, committees: committees }));

        /**sort subgroups array and set(mutate) state */
        subgroups.sort();
        set((state: any) => ({ ...state, subgroups: subgroups }));

        /**sort meeting types array and set(mutate) state */
        meetingtypes.sort();
        set((state: any) => ({ ...state, meetingtypes: meetingtypes }));

        /**sort venues array and set(mutate) state */
        venues.sort();
        //console.log(venues)
        set((state: any) => ({ ...state, venues: venues }));

        /**sort agendaitems array and set(mutate) state */
        agendaitems.sort();
        set((state: any) => ({ ...state, agendaitems: agendaitems }));

        /**sort new and past sessions array by date and set state */
        //sort data by date from asc

        pastSessions.sort(function (a: any, b: any) {
          const dateA = dayjs(a.start);
          //console.log(a.start);
          const dateB = dayjs(b.start);

          return dateA.diff(dateB);
        });

        newSessions.sort(function (a: any, b: any) {
          const dateA = dayjs(a.start);
          //console.log(a.start);
          const dateB = dayjs(b.start);

          return dateA.diff(dateB);
        });

        set((state: any) => ({ ...state, sessions: newSessions }));

        set((state: any) => ({ ...state, pastSessions: pastSessions }));
        set((state: any) => ({ ...state, newSessions: newSessions }));
      });

    // Rebuild the MUI datatable data
    get().buildMUIDataSessions();
  },

  // Build the MUI datatable data
  buildMUIDataSessions: async () => {
    // Set loading to true
    get().toggleLoading(true);

    // Define empty data grid
    let rows: any[] = [];
    let columns: any[] = [];
    let dataGrid = { rows: rows, columns: columns };

    // get datagrid columns depending on the datasource. see function changeColumnsGrid
    // set columns
    set((state: any) => ({ ...state, columnsGridSessions: ColumnsSessions }));

    dataGrid.columns = get().columnsGridSessions;
    dataGrid.rows = rows; //inititialize rows

    //check if filters ís activated and set filtering state
    get().setFiltering();

    //let isFiltering = get().isFiltering;
    //console.log('filters activated' + isFiltering)

    //initialize the pagination
    get().changeCurrentSessionPage(1);

    // Loop through the sessions order
    const sessions = get().sessions;
    //console.log(sessions)
    //const datasource = get().settings.params.datasource;

    //initialize datagrid state
    set((state: any) => ({ ...state, MUIdataSessions: dataGrid }));

    sessions.length > 0 &&
      sessions.forEach((session: any) => {
        //build event calendar item

        const startDay = dayjs(session.start).format('DD/MM/YYYY');
        const startTime = dayjs(session.start).format('HH:mm');

        const endDay = dayjs(dayjs(session.end)).format('DD/MM/YYYY');
        const endTime = dayjs(dayjs(session.end)).format('HH:mm');

        // Define a new row with columns common to all list types
        let newRow: any = {
          id: session.id,
          MeetingType: session.type,
          EventTitle: session.eventTitle,
          MonitorTitle: session.name,
          DateSession: startDay,
          TimeSession: startTime,
          EndDaySession: endDay,
          EndTimeSession: endTime,
          Building: session.building,
          SectorSession: session.sector,
          Venue: session.building + ' - ' + session.room,
          TimeSessionStartEnd: startTime + ' - ' + endTime,
          RoomName: session.room,
          RegisterURL: session.registerURL,
          JoinURL: session.joinURL,
          isRegistered: session.isRegistered,
          Message: session.message, //invitation to
          Notes: session.eventCalendarNote, //note
          Type: session.type, //session type (social events, etc)
          Committee: session.committee, //commitee
          SubGroup: session.subGroup,
          //CommitteeSubGroup:  session.building + ' - ' + session.subGroup,
          AgendaItems: session.agendaItems, //.toString(), //agenda items
          DocumentNumber: session.documentNumber //agenda
        };

        let CommitteeSubGroup = '';
        if (session.committee !== '' && session.committee !== undefined)
          CommitteeSubGroup = session.committee;

        if (CommitteeSubGroup !== '') {
          if (session.subGroup !== '' && session.subGroup !== undefined)
            CommitteeSubGroup += ' / ' + session.subGroup;
        } else if (session.subGroup !== '' && session.subGroup !== undefined)
          CommitteeSubGroup += session.subGroup;

        newRow.CommitteeSubGroup = CommitteeSubGroup;

        //console.log(newRow)

        // Push new row to datagrid rows array
        dataGrid.rows.push(newRow);
      });

    // APPLY FILTERS
    //sector filtering
    //console.log(get().filters.SectorSession)
    if (get().filters.SectorSession.length > 0) {
      dataGrid.rows = dataGrid.rows.filter((row) =>
        get().filters.SectorSession.includes(row.SectorSession)
      );
    }

    //console.log(dataGrid.rows)

    //committee filtering
    if (get().filters.Committee.length > 0) {
      dataGrid.rows = dataGrid.rows.filter((row) => {
        const rowValue = row.Committee;
        const filterValue = get().filters.Committee;

        return filterValue.includes(rowValue);
      });
    }

    // console.log(dataGrid.rows)

    //subgroup filtering
    if (get().filters.SubGroup.length > 0) {
      dataGrid.rows = dataGrid.rows.filter((row) => {
        const rowValue = row.SubGroup;
        const filterValue = get().filters.SubGroup;

        return filterValue.includes(rowValue);
      });
    }

    // console.log(dataGrid.rows)

    // If MeetingType filter
    //console.log('meeting type: ' + get().filters.MeetingType)
    if (get().filters.MeetingType.length > 0) {
      dataGrid.rows = dataGrid.rows.filter((row) => {
        //row.MeetingType === get().filters.MeetingType
        const rowValue = row.MeetingType;
        const filterValue = get().filters.MeetingType;
        //const includes = rowValue.includes(filterValue)
        //console.log(rowValue + ' includes ' + filterValue + ':' + includes)

        return filterValue.includes(rowValue);
      });
    }

    // console.log(dataGrid.rows)

    //venue filtering
    //console.log(get().filters.Venue)
    if (get().filters.Venue.length > 0) {
      dataGrid.rows = dataGrid.rows.filter((row) => {
        const rowValue = row.Venue;
        const filterValueArr = get().filters.Venue;

        //Check an array of strings filterValueArr contains a substring rowValue
        const isFilterMatchingRowvalue = filterValueArr.some((str: any) => {
          //console.log(rowValue + ' compared to ' + str)
          return rowValue.trim().includes(str.trim());
        }); //  filterValueArr.filter((str: any) => str.includes(rowValue));

        //console.log('row value : ' + rowValue)
        //console.log('filter array value : ' + filterValueArr)
        //console.log('sub array : ' + subArr)

        return isFilterMatchingRowvalue;
      });
    }

    //console.log(dataGrid.rows)

    // If Agendaitem filter
    //console.log('filter agendaitem: ' + get().filters.Agendaitem)
    if (get().filters.Agendaitem.length > 0) {
      dataGrid.rows = dataGrid.rows.filter((row) => {
        const rowValue = row.AgendaItems;
        const filterValue = get().filters.Agendaitem;

        const filterValueArr = filterValue.toString().split(',');
        //const rowValueArr = rowValue.toString().split(',');
        const found = filterValueArr.some((r: any) => rowValue.includes(r));

        //console.log(rowValue + ' compared to ' + filterValueArr + ' equal: ' + found)

        return found;

        //return row.Agendaitem === get().filters.Agendaitem
      });
    }

    //console.log(dataGrid.rows)

    // If date filter
    //        console.log(get().filters.DateSession)
    //console.log(dayjs(get().filters.DateSession).format('DD/MM/YYYY'))
    // console.log(dayjs(get().filters.DateSession.$d).format('DD/MM/YYYY'))
    //console.log('date filter= ' + get().filters.DateSession.$d)

    //if (get().filters.DateSession.$d !== undefined) {
    if (get().filters.DateSession !== undefined) {
      const dateSessionFilter = get().filters.DateSession; //dayjs(get().filters.DateSession.$d).format('DD/MM/YYYY')

      if (dateSessionFilter && dateSessionFilter.length > 0) {
        dataGrid.rows = dataGrid.rows.filter((row) => {
          const rowdate = row.DateSession;
          //const filterdate = get().filters.DateSession
          //console.log('rowdate: ' + rowdate + ' compared to ' + dateSessionFilter + ' : ' + rowdate.includes(dateSessionFilter))
          return rowdate.includes(dateSessionFilter); //rowdate === dateSessionFilter
        });
      }
    }

    // If time filter
    if (get().filters.TimeSession.length > 0) {
      dataGrid.rows = dataGrid.rows.filter((row) => row.TimeSession === get().filters.TimeSession);
    }

    // If search filter
    //console.log(get().filters.searchSession)
    if (get().filters.searchSession.length > 0 && get().filters.searchSession !== undefined) {
      dataGrid.rows = dataGrid.rows.filter(
        (row) =>
          row.MeetingType.toLowerCase().includes(get().filters.searchSession.toLowerCase()) ||
          row.MonitorTitle.toLowerCase().includes(get().filters.searchSession.toLowerCase()) ||
          row.DateSession?.toLowerCase().includes(get().filters.searchSession.toLowerCase()) ||
          row.RoomName?.toLowerCase().includes(get().filters.searchSession.toLowerCase()) /*|| 
              row.TimeSessionStartEnd?.toLowerCase().includes(get().filters.search.toLowerCase()) 
             */
      );
    }

    //console.log(dataGrid.rows)

    // If MySessions filter for logged-in users
    //console.log(get().filters.MySessions)
    if (get().filters.MySessions === 1) {
      dataGrid.rows = dataGrid.rows.filter((row) => {
        const isRegistered = row.isRegistered;
        //console.log(Number(row.isRegistered))
        const filterMySessions = get().filters.MySessions;
        //console.log('isRegistered: ' + isRegistered + ' compared to filterMySessions : ' + filterMySessions)
        //return rowdate.includes(dateSessionFilter) //rowdate === dateSessionFilter
        return row.isRegistered;
      });
    }
    // console.log(dataGrid.rows);

    // Save the datagrid to the store
    set((state: any) => ({ ...state, MUIdataSessions: dataGrid }));

    // Set loading to false
    //setTimeout(() => get().toggleLoading(false),10000);
    //});

    get().toggleLoading(false);
  },

  // Build the MUI datatable data
  buildMUIDataEvents: async () => {
    // Set loading to true
    get().toggleLoading(true);

    // Define empty data grid
    let rows: any[] = [];
    let columns: any[] = [];
    let dataGrid = { rows: rows, columns: columns };

    // set columns
    set((state: any) => ({ ...state, columnsGridEvents: ColumnsEvents }));
    dataGrid.columns = get().columnsGridEvents;
    //dataGrid.rows = rows //inititialize rows

    //check if filters are activated and set filtering state
    get().setFiltering();
    //let isFiltering = get().isFiltering;
    //console.log('filters activated'+isFiltering)

    //initialize the pagination
    get().changeCurrentEventPage(1);

    // Loop through the events order
    const events = get().events;
    //const datasource = get().settings.params.datasource;

    events.length > 0 &&
      events.forEach((event: any) => {
        const startDay = dayjs(event.start).format('DD/MM/YYYY');
        const startTime = dayjs(event.start).format('HH:mm');

        const endDay = dayjs(dayjs(event.end)).format('DD/MM/YYYY');
        const endTime = dayjs(dayjs(event.end)).format('HH:mm');

        // Define a new row with columns common to all list types
        let newRow: any = {
          id: event.eventId,
          Status: event.status,
          Format: event.format,
          DateEvent: startDay,
          TimeEvent: startTime,
          EndDayEvent: endDay,
          EndTimeEvent: endTime,
          Title: event.title,
          Place: event.place,
          SectorEvent: event.sector,
          TimeEventStartEnd: startTime + ' - ' + endTime,
          DateEventStartEnd: startDay + ' - ' + endDay,
          Type: event.type,
          EventURL: event.eventURL,
          ImageURL: event.imageURL,
          Group: event.group,
          SectorGroup: event.group + ' - ' + event.sector,
          RegistrationURL: event.registrationURL,
          Topics: event.topics,
          Start: event.start,
          End: event.end,
          EventId: event.eventId,
          EventType: event.eventtype
        };

        //console.log(newRow.MonitorTitle)

        // Push new row to datagrid rows array
        dataGrid.rows.push(newRow);
        // APPLY FILTERS

        //sector filtering
        //console.log(get().filters.SectorEvent)
        if (get().filters.SectorEvent.length > 0) {
          dataGrid.rows = dataGrid.rows.filter((row) =>
            get().filters.SectorEvent.includes(row.SectorEvent)
          );
        }

        // If date filter
        if (get().filters.DateEvent && get().filters.DateEvent.length > 0) {
          dataGrid.rows = dataGrid.rows.filter((row) => row.DateEvent === get().filters.DateEvent);
        }
        // If time filter
        if (get().filters.TimeEvent.length > 0) {
          dataGrid.rows = dataGrid.rows.filter((row) => row.TimeEvent === get().filters.TimeEvent);
        }

        // If Format filter
        //console.log(get().filters.Format)
        if (get().filters.Formats.length > 0) {
          dataGrid.rows = dataGrid.rows.filter((row) => get().filters.Formats.includes(row.Format));
        }

        // If Type filter
        //console.log(get().filters.Type)
        if (get().filters.Types.length > 0) {
          dataGrid.rows = dataGrid.rows.filter((row) => get().filters.Types.includes(row.Type));
        }

        // If Group
        //console.log(get().filters.Group)
        if (get().filters.Groups.length > 0) {
          dataGrid.rows = dataGrid.rows.filter((row) => get().filters.Groups.includes(row.Group));
        }

        // If Sector Group
        //console.log(get().filters.Group)
        if (get().filters.SectorGroups.length > 0) {
          dataGrid.rows = dataGrid.rows.filter((row) =>
            get().filters.SectorGroups.includes(row.SectorGroup)
          );
        }

        // If search filter
        if (get().filters.searchEvent.length > 0) {
          dataGrid.rows = dataGrid.rows.filter(
            (row) =>
              row.Type.toLowerCase().includes(get().filters.searchEvent.toLowerCase()) ||
              row.Format.toLowerCase().includes(get().filters.searchEvent.toLowerCase()) ||
              row.Place.toLowerCase().includes(get().filters.searchEvent.toLowerCase()) ||
              row.SectorEvent.toLowerCase().includes(get().filters.searchEvent.toLowerCase()) ||
              row.Status.toLowerCase().includes(get().filters.searchEvent.toLowerCase()) ||
              row.Title.toLowerCase().includes(get().filters.searchEvent.toLowerCase()) ||
              row.DateEvent?.toLowerCase().includes(get().filters.searchEvent.toLowerCase()) ||
              row.Topics?.toLowerCase().includes(get().filters.searchEvent.toLowerCase()) ||
              row.SectorGroup?.toLowerCase().includes(get().filters.searchEvent.toLowerCase())
          );
        }

        // Save the datagrid to the store
        set((state: any) => ({ ...state, MUIdataEvents: dataGrid }));
      });

    // Set loading to false
    get().toggleLoading(false);
  }
}));

// If dev env add devtools
if (process.env.NODE_ENV === 'development') {
  mountStoreDevtool('Zustand store', useStore);
}
export default useStore;
